module.exports = __webpack_public_path__ + "media/bootstrap-icons/vr-f227f667.svg";